import '@babel/polyfill';
// test
import React from 'react';
import ReactDOM from 'react-dom';

import App from './app';

import '@babel/polyfill';

import jquery from 'jquery';

// @ts-ignore
window.jQuery = window.$ = jquery;

import 'bootstrap';
import 'bootstrap/js/dist/util';
import 'bootstrap/dist/css/bootstrap.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcVisa
} from '@fortawesome/free-brands-svg-icons';

import {
  faCreditCard,
  faThumbsUp,
  faThumbsDown,
  faComment,
  faTimesCircle
} from '@fortawesome/free-regular-svg-icons';

import {
  faUserCircle,
  faBars,
  faEnvelope,
  faAt,
  faLock,
  faExclamationCircle,
  faTimes,
  faCalendar,
  faPhone,
  faPortrait,
  faChevronLeft,
  faChevronRight,
  faHeart,
  faSearch,
  faCircle,
  faCamera,
  faKey,
  faEllipsisV,
  faEye,
  faEyeSlash
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faUserCircle,
  faBars,
  faEnvelope,
  faAt,
  faLock,
  faExclamationCircle,
  faTimes,
  faEllipsisV,
  faCalendar,
  faPhone,
  faPortrait,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcVisa,
  faCreditCard,
  faChevronLeft,
  faChevronRight,
  faThumbsUp,
  faThumbsDown,
  faHeart,
  faSearch,
  faCircle,
  faCamera,
  faKey,
  faEye,
  faEyeSlash,
  faComment,
  faTimes
);

import './app.css';
import './footer.css';
import './overrides.css';
import './image.css';
import './chat.css';

App.then((AppInstance: App) =>
  ReactDOM.render(<AppInstance />, document.getElementById('root'))
);
